var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "top-right-btn", style: _vm.style },
    [
      _vm.columns.length > 0
        ? _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: { effect: "dark", content: "显隐列", placement: "top" },
            },
            [
              _c("i", {
                staticClass: "el-icon-setting",
                on: { click: _vm.showColumn },
              }),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.open,
            width: "620px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "pb20" },
            [
              _c("el-transfer", {
                attrs: { titles: ["显示", "隐藏"], data: _vm.columns },
                on: { change: _vm.dataChange },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }